import type { MenuConfig } from '~typings/menu'

export default [
    {
        title: 'inventario.menu_title',
        fontIcon: 'archive',
        resource: 'Inventario',
        action: 'ver-inventario',
        children: [
            {
                title: 'global.menu.dashboard',
                route: 'inventario-dashboard',
                resource: 'Inventario',
                action: 'ver-inventario-dashboard',
            },

            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Inventario',
                action: 'ver-inventario-transacciones',
                children: [
                    {
                        title: 'inventario.subopciones.consumo',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-consumo',
                        children: [
                            {
                                route: 'inventario-transacciones-aprobacion-solicitud-consumo',
                                title: 'inventario.subopciones.aprobacion_solicitud_consumo',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-aprobacion-solicitud-consumo',
                            },
                            {
                                route: 'inventario-transacciones-gestion-solicitud-consumo',
                                title: 'inventario.subopciones.gestion_solicitud_consumo',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-gestion-solicitud-consumo',
                            },
                            {
                                route: 'inventario-transacciones-solicitud-consumo',
                                title: 'inventario.subopciones.solicitud_consumo',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-solicitud-consumo',
                            },
                        ],
                    },
                    {
                        title: 'inventario.subopciones.devolucion',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-devolucion',
                        children: [
                            {
                                route: 'inventario-transacciones-aprobacion-solicitud-devolucion',
                                title: 'inventario.subopciones.aprobacion_solicitud_devolucion',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-aprobacion-solicitud-devolucion',
                            },
                            {
                                route: 'inventario-transacciones-gestion-solicitud-devolucion',
                                title: 'inventario.subopciones.gestion_solicitud_devolucion',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-gestion-solicitud-devolucion',
                            },
                            {
                                route: 'inventario-transacciones-solicitud-devolucion',
                                title: 'inventario.subopciones.solicitud_devolucion',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-solicitud-devolucion',
                            },
                        ],
                    },
                    {
                        title: 'inventario.subopciones.transferencia',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-transferencia',
                        children: [
                            {
                                route: 'inventario-transacciones-aprobacion-solicitud-transferencia',
                                title: 'inventario.subopciones.aprobacion_solicitud_transferencia',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-aprobacion-solicitud-transferencia',
                            },
                            {
                                route: 'inventario-transacciones-gestion-solicitud-transferencia',
                                title: 'inventario.subopciones.gestion_solicitud_transferencia',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-gestion-solicitud-transferencia',
                            },
                            {
                                route: 'inventario-transacciones-solicitud-transferencia',
                                title: 'inventario.subopciones.solicitud_transferencia',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-solicitud-transferencia',
                            },
                        ],
                    },
                    {
                        route: 'inventario-transacciones-egreso-bodega',
                        title: 'inventario.subopciones.egreso_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-egreso-bodega',
                    },
                    {
                        route: 'inventario-transacciones-ingreso-bodega',
                        title: 'inventario.subopciones.ingreso_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-ingreso-bodega',
                    },
                    {
                        route: 'inventario-transacciones-transferencia-bodega',
                        title: 'inventario.subopciones.transferencia_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-transferencia-bodega',
                    },
                    {
                        title: 'inventario.subopciones.orden_pedido',
                        resource: 'Inventario',
                        action: 'ver-inventario-transacciones-orden-pedido',
                        children: [
                            {
                                route: 'inventario-transacciones-orden-pedido-nuevo',
                                title: 'inventario.subopciones.nuevo_pedido',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-orden-pedido-nuevo',
                            },
                            {
                                route: 'inventario-transacciones-orden-pedido-gestion',
                                title: 'inventario.subopciones.gestion_pedido',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-orden-pedido-gestion',
                            },
                            {
                                route: 'inventario-transacciones-orden-pedido-aprobacion',
                                title: 'inventario.subopciones.aprobacion_pedido',
                                resource: 'Inventario',
                                action: 'ver-inventario-transacciones-orden-pedido-aprobacion',
                            },
                        ],
                    },
                ],
            },

            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Inventario',
                action: 'ver-inventario-configuracion',
                children: [
                    {
                        route: 'inventario-configuracion-crear-inventario',
                        title: 'inventario.subopciones.crear_tipo_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-configuracion-crear-inventario',
                    },
                    {
                        route: 'inventario-configuracion-crear-bodega',
                        title: 'inventario.subopciones.crear_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-configuracion-crear-bodega',
                    },
                    {
                        route: 'inventario-configuracion-asignar-jefe-bodega',
                        title: 'inventario.subopciones.asignar_jefe_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-configuracion-asignar-jefe-bodega',
                    },
                    {
                        route: 'inventario-configuracion-permisos-bodega',
                        title: 'inventario.subopciones.permisos_bodega',
                        resource: 'Inventario',
                        action: 'ver-inventario-configuracion-permisos-bodega',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Inventario',
                action: 'ver-inventario-informes',
                children: [
                    {
                        route: 'inventario-informes-kardex',
                        title: 'inventario.subopciones.kardex',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-kardex',
                    },
                    {
                        route: 'inventario-informes-estado-inventario',
                        title: 'inventario.subopciones.stock_inventario',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-estado-inventario',
                    },
                    {
                        route: 'inventario-informes-movimiento-inventario',
                        title: 'inventario.subopciones.movimiento_inventario',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-movimiento-inventario',
                    },
                    {
                        route: 'inventario-informes-stock-minimo',
                        title: 'inventario.subopciones.stock_minimo',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-stock-minimo',
                    },
                    {
                        route: 'inventario-informes-resumen-inventario',
                        title: 'inventario.subopciones.resumen_inventario',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-resumen-inventario',
                    },
                    {
                        route: 'inventario-informes-nota-ingreso-egreso',
                        title: 'inventario.subopciones.nota-ingreso-egreso',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-nota-ingreso-egreso',
                    },
                    {
                        route: 'inventario-informes-informe-reposicion',
                        title: 'inventario.subopciones.informe-reposicion',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-informe-reposicion',
                    },
                    {
                        route: 'inventario-informes-toma-inventario',
                        title: 'inventario.subopciones.toma-inventario',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-toma-inventario',
                    },
                    {
                        route: 'inventario-informes-informe-stock-minimo',
                        title: 'inventario.subopciones.informe-stock-minimo',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-informe-stock-minimo',
                    },
                    {
                        route: 'inventario-informes-rotacion-inventario',
                        title: 'inventario.subopciones.rotacion-inventario',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-rotacion-inventario',
                    },
                    {
                        route: 'inventario-informes-movimiento-inventario-general',
                        title: 'inventario.subopciones.movimiento-inventario-general',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-movimiento-inventario-general',
                    },
                    {
                        route: 'inventario-informes-movimiento-transferencias-automaticas',
                        title: 'inventario.subopciones.movimiento-transferencias-automaticas',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-movimiento-transferencias-automaticas',
                    },
                    {
                        route: 'inventario-informes-rotacion-antiguedad-inventario',
                        title: 'inventario.subopciones.rotacion-antiguedad-inventario',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-rotacion-antiguedad-inventario',
                    },
                    {
                        route: 'inventario-informes-estado-inventario-costo',
                        title: 'inventario.subopciones.estado-inventario-costo',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-estado-inventario-costo',
                    },
                    {
                        route: 'inventario-informes-estado-inventario-rotacion',
                        title: 'inventario.subopciones.estado-inventario-rotacion',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-estado-inventario-rotacion',
                    },
                    {
                        route: 'inventario-informes-politicas-item',
                        title: 'inventario.subopciones.politicas_item',
                        resource: 'Inventario',
                        action: 'ver-inventario-informes-politicas-item',
                    },
                ],
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Inventario',
                action: 'ver-inventario-mantenimiento',
                children: [
                    {
                        route: 'inventario-mantenimiento-permisos-aprobacion',
                        title: 'Permisos Aprobación',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-permisos-aprobacion',
                    },
                    {
                        route: 'inventario-mantenimiento-mis-solicitudes-item',
                        title: 'inventario.subopciones.mis_solicitudes',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-mis-solicitudes-item',
                    },
                    {
                        route: 'inventario-mantenimiento-aprobacion-linea',
                        title: 'inventario.subopciones.aprobacion_linea',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-aprobacion-linea',
                    },
                    {
                        route: 'inventario-mantenimiento-orden-pedido-permisos-niveles-aprobacion',
                        title: 'inventario.subopciones.permisos_niveles_aprobacion_orden_pedido',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-orden-pedido-permisos-niveles-aprobacion',
                    },
                    {
                        route: 'inventario-mantenimiento-aprobacion-items',
                        title: 'inventario.subopciones.aprobacion_items',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-aprobacion-items',
                    },
                    {
                        route: 'inventario-mantenimiento-aprobacion-tributaria-items',
                        title: 'inventario.subopciones.aprobacion_trib_items',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-aprobacion-tributaria-items',
                    },
                    {
                        route: 'inventario-mantenimiento-aprobacion-contable-items',
                        title: 'inventario.subopciones.aprobacion_cont_items',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-aprobacion-contable-items',
                    },
                    {
                        route: 'inventario-mantenimiento-crear-categoria',
                        title: 'inventario.subopciones.crear_categoria',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-crear-categoria',
                    },
                    {
                        route: 'inventario-mantenimiento-crear-linea',
                        title: 'inventario.subopciones.crear_linea',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-crear-linea',
                    },
                    {
                        route: 'inventario-mantenimiento-solicitud-item',
                        title: 'inventario.subopciones.soli_item',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-solicitud-item',
                    },
                    {
                        route: 'inventario-mantenimiento-politica-item',
                        title: 'inventario.subopciones.politica_items',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-politica-item',
                    },
                    {
                        route: 'inventario-mantenimiento-crear-marca',
                        title: 'inventario.subopciones.crear_marca',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-crear-marca',
                    },
                    {
                        route: 'inventario-mantenimiento-solicitud-marca',
                        title: 'inventario.subopciones.solicitud_marca',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-solicitud-marca',
                    },
                    {
                        route: 'inventario-mantenimiento-aprobacion-marca',
                        title: 'inventario.subopciones.aprobacion_marca',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-aprobacion-marca',
                    },
                    {
                        route: 'inventario-mantenimiento-gestion-item',
                        title: 'inventario.subopciones.gestion_item',
                        resource: 'Inventario',
                        action: 'ver-inventario-mantenimiento-gestion-item',
                    },
                ],
            },
        ],
    },
] as MenuConfig[]
